export { buildStackFrame } from './buildStackFrame';

export { getDataFromSafariExtensions } from './getDataFromSafariExtensions';

export { getStackFramesFromError } from './getStackFramesFromError';

export { parseStacktrace } from './parseStacktrace';



// WEBPACK FOOTER //
// ../../../../../src/instrumentations/errors/stackFrames/index.ts